import React from 'react';
import { classnames, getTrans, replaceParams } from '@/utils/tools';
import { BUTTON_TYPE, Copywriting } from '@/utils/constants';
import { isSupportFacialVerification, jumpToHelpCenter } from '@/utils/tools/face';
import Msg from '@/components/Msg';
import SingleButton, { getClassName, getDisabledClassName } from '@/components/SingleButton';
import './index.scss';
import ConfirmModal from '@/components/General/ConfirmModal';
import VersionUpdateModal from '../VersionUpdateModal';

// 人脸识别消息
function FacialVerificationMsg() {
  const msgText = getTrans(Copywriting.FACIAL_VERIFICATION_TIP);
  const buttonText = getTrans(Copywriting.FACIAL_VERIFICATION_BUTTON);

  function getButtonDisabled() {
    return true;
  }
  const isDisable = getButtonDisabled();

  const btnClassName = isDisable ? getDisabledClassName(BUTTON_TYPE.TRADITIONAL) : getClassName(BUTTON_TYPE.TRADITIONAL);


  const buttonProps = {
    className: classnames('button-container', btnClassName),
    text: buttonText,
    handleClick: () => { },
    disabled: isDisable,
  };


  return (<div className="facial-verification-msg">
    <Msg content={msgText} />
    <div className="buttons">
      <SingleButton {...buttonProps} />
    </div>
  </div>);
}

// 更新版本消息
function UpdateVersionMsg() {
  const msgText = getTrans(Copywriting.FACIAL_VERIFICATION_UPDATE_VERSION_TIP);
  const updateVersionText = getTrans(Copywriting.FACIAL_VERIFICATION_UPDATE_VERSION_LINK);
  const helpCenterText = getTrans(Copywriting.FACIAL_VERIFICATION_HELP_CENTER_LINK);

  function popUpVersionUpdateModal() {
    const versionUpdateModal = ConfirmModal({
      className: 'version-update-modal',
      title: '',
      content: (<VersionUpdateModal onClose={() => versionUpdateModal.destroy()} />),
      footer: [],
    });
  }
  const getUpdateVersionBtn = () => {
    return (
      <span className="btn-link" onClick={popUpVersionUpdateModal}>
        {updateVersionText}
      </span>
    );
  };

  const getHelpCenterBtn = () => {
    return (
      <span className="btn-link" onClick={jumpToHelpCenter}>
        {helpCenterText}
      </span>
    );
  };
  const showMsg = replaceParams(msgText, {
    updateVersionBtn: getUpdateVersionBtn(),
    helpCenterBtn: getHelpCenterBtn(),
  });
  return (
    <div className="msg-container-wrapper">
      <div className="update-version-msg">
        {showMsg}
      </div>
    </div>);
}

export default function FacialVerification() {

  if (isSupportFacialVerification()) {
    return <FacialVerificationMsg />;
  } else {
    return <UpdateVersionMsg />;
  }

}
